const rewardContainer = document.getElementById("reward-container");
window.addEventListener("resize", function (event) {
  if (window.innerWidth <= 768) {
    var lastScrollTop = 0;
    window.addEventListener("scroll", function () {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop < lastScrollTop && window.scrollY > 160) {
        //scroll up
        rewardContainer.style.top = "105px";
      } else {
        rewardContainer.style.top = "0px";
      }
      lastScrollTop = scrollTop;
    });
  } else {
      rewardContainer.style.top = null;
      rewardContainer.style.bottom = "5px";
    window.addEventListener("scroll", function () {
      rewardContainer.style.top = null;
      rewardContainer.style.bottom = "5px";
    });
  }
});
